import { useSelector } from '@legendapp/state/react';

import { appStore } from '@/core/stores';

export const useAppInstanceId = () => {
	return useSelector(() => appStore.appMeta.id.get());
};

export const useClusterId = () => {
	return useSelector(() => appStore.appMeta.clusterId.get());
};

export const useTenantId = () => {
	return useSelector(() => appStore.appMeta.tenantId?.get());
};
